module.exports = __webpack_public_path__ + "img/refresh.0601dc92.png";